module.exports = __webpack_public_path__ + "static/media/carro.7caf2320.png";